import ChallengeItemDetail from './ChallengeItemDetail';

export default ChallengeItemDetail;
